import { useEffect, useState } from "react";

import SweetAlert from "react-bootstrap-sweetalert";
import { connect, useDispatch } from "react-redux";
import {
  getCollege,
  deleteCollege,
  getColleges,
} from "../../../../../action/masters/collegeActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  ICollegeIndex,
  ICollegeData,
} from "../../../../../models/master/college";
import { setColleges } from "../../../../../store/slices/common/commonSlice";
import ViewCollege from "./viewCollege";
import CollegeCreate from "./collegeCreate";
import CollegeEdit from "./collegeEdit";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";

const CollegesIndex = (props: ICollegeIndex) => {
  const {
    getColleges,
    colleges,
    getCollege,
    college,
    deleteCollege,
    currentUser,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [isViewLoading, setIsViewLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const editItem = async (id: number) => {
    setShowEdit(true);
    setIsEditLoading(true);
    try {
      await getCollege(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const viewItem = async (id: number) => {
    setShowView(true);
    setIsViewLoading(true);
    try {
      await getCollege(id);
    } finally {
      setIsViewLoading(false);
    }
  };

  const getAllColleges = async () => {
    setIsLoading(true);
    try {
      await getColleges();
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenModalCreate = () => {
    setShowCreate(true);
  };
  const handleCloseModalCreate = () => {
    setShowCreate(false);
  };

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteCollege(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllColleges();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  useEffect(() => {
    getAllColleges();
    return () => {
      dispatch(setColleges([]));
    };
  }, []);

  return (
    <>
      <div className="admin-wrap">
        <div className="admincontent">
          <div className="title">
            <h2>University Management</h2>
            <a
              href="javascript:void(0)"
              className="btn btn-primary"
              onClick={handleOpenModalCreate}
            >
              <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
              Add New
            </a>
          </div>
          <ul className="d-flex gap-3 flex-wrap mt-28">
            {isLoading ? (
              <LoaderSpinner />
            ) : colleges && colleges.length > 0 ? (
              colleges.map((college: ICollegeData) => {
                return (
                  <li
                    className="admin-card"
                    style={{
                      pointerEvents: !college.isActive ? "none" : "auto",
                      opacity: !college.isActive ? 0.5 : 1,
                    }}
                  >
                    <div className="top">
                      <div className="btn-flex">
                        <button
                          className="btn-view"
                          data-bs-toggle="modal"
                          data-bs-target="#viewdepartment"
                          onClick={() => viewItem(college.id ?? 0)}
                        >
                          <img src="/assets/images/icon/eye-wh.svg" alt="" />
                        </button>
                        <button
                          className="btn-edit"
                          onClick={() => editItem(college.id ?? 0)}
                        >
                          <img src="/assets/images/icon/edit-wh.svg" alt="" />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => deleteItem(college.id ?? 0)}
                        >
                          <img src="/assets/images/icon/trash-wh.svg" alt="" />
                        </button>
                      </div>
                    </div>
                    <div className="btm">
                      <div className="img">
                        <img
                          src={
                            college.collegeLogo
                              ? baseURL + college.collegeLogo
                              : ""
                          }
                          alt=""
                          className="w-50 mb-2"
                        />
                      </div>
                      <h2>{college.collegeName}</h2>
                    </div>
                  </li>
                );
              })
            ) : (
              <p>No Records Found</p>
            )}
          </ul>

          {isEditLoading ? (
            <LoaderSpinner />
          ) : (
            <ReactModal
              isOpen={showCreate}
              onRequestClose={handleCloseModalCreate}
              className="react-modal-content"
              overlayClassName="react-modal-overlay"
              shouldCloseOnOverlayClick={false}
            >
              <CollegeCreate
                setShowCreate={handleCloseModalCreate}
                getAllColleges={() => getAllColleges()}
              />
            </ReactModal>
          )}

          {isEditLoading ? (
            <LoaderSpinner />
          ) : (
            <ReactModal
              isOpen={showEdit}
              onRequestClose={() => {
                setShowEdit(false);
              }}
              className="react-modal-content"
              overlayClassName="react-modal-overlay"
              shouldCloseOnOverlayClick={false}
            >
              {showEdit && college && (
                <CollegeEdit
                  college={college}
                  setShowEdit={(e: boolean) => {
                    setShowEdit(e);
                  }}
                  getAllColleges={getAllColleges}
                  currentUser={currentUser}
                />
              )}
            </ReactModal>
          )}

          {isViewLoading ? (
            <LoaderSpinner />
          ) : (
            <ReactModal
              isOpen={showView}
              onRequestClose={() => {
                setShowView(false);
              }}
              className="react-modal-content"
              overlayClassName="react-modal-overlay"
              shouldCloseOnOverlayClick={false}
            >
              {showView && college && (
                <ViewCollege
                  college={college}
                  setShowView={(e: boolean) => {
                    setShowView(e);
                  }}
                />
              )}
            </ReactModal>
          )}

          <SweetAlert
            show={showAlert}
            success={false}
            type={alertType}
            title={alertTitle}
            onConfirm={() => onConfirm()}
            showCancel={isDelete}
            onCancel={() => {
              setShowAlert(false);
              setIsDelete(false);
            }}
            cancelBtnText={"No"}
            confirmBtnText={isDelete ? "Yes" : "Ok"}
          />
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getColleges: () => getColleges(),
  getCollege: (id: number) => getCollege(id),
  deleteCollege: (id: number, callBack: Function) =>
    deleteCollege(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    colleges: state.college.colleges,
    college: state.college.college,
    currentUser: state.userDetails.userProfileData?.currentRole,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollegesIndex);
